module.exports = __webpack_public_path__ + "bm.svg?e71b682812c95eea10adf0cd8763ecf3";